import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import generate from "shortid";
import ImageMap from "image-map";
import ImageMapper from "../ImageMapper/ImageMapper";
// import ImageMap from "../../vendor/image-map";
import { PlayerTooltip } from "../..";

class ImageMarker extends Component {
  imgRef = React.createRef();

  static propTypes = {
    courtSketch: PropTypes.string.isRequired,
    hasTooltip: PropTypes.bool,
    imageHeight: PropTypes.number,
    imageWidth: PropTypes.number,
    isClickable: PropTypes.bool,
    isOneSide: PropTypes.bool,
    mapAreas: PropTypes.array,
    markerColor: PropTypes.string,
    markers: PropTypes.array,
    markerSize: PropTypes.number,
    onMapClick: PropTypes.func
  };

  static defaultProps = {
    hasTooltip: false,
    imageHeight: 488,
    imageWidth: 758,
    isClickable: true,
    isOneSide: false,
    mapAreas: [],
    markerColor: "red",
    markers: [],
    markerSize: 8,
    onMapClick: () => {}
  };

  state = {
    mapMarkers: this.props.markers
  };

  componentDidMount() {
    ImageMap("img[usemap]");
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!nextProps.isClickable && nextProps.markers !== prevState.mapMarkers) {
      return {
        mapMarkers: nextProps.markers
      };
    }
    return null;
  }

  calcXCoord = mark => {
    const xScale = this.props.isOneSide
      ? mark.x * this.props.imageWidth * 2
      : mark.x * this.props.imageWidth;
    // TODO: check on rotate coord
    const xCoord =
      mark.side === "R" && this.props.isOneSide
        ? this.props.imageWidth * 2 - xScale
        : xScale;
    return xCoord;
  };

  calcYCoord = mark => {
    const yScale = mark.y * this.props.imageHeight;
    const yCoord =
      mark.side === "R" && this.props.isOneSide
        ? this.props.imageHeight - yScale
        : yScale;
    return yCoord;
  };

  handleMapClick = (e, title, side) => {
    const bounds = this.imgRef.current.getBoundingClientRect();
    const xCoord = (e.clientX - bounds.left) / this.imgRef.current.width;
    const yCoord = (e.clientY - bounds.top) / this.imgRef.current.height;
    const marker = { position: { x: xCoord, y: yCoord, side, area: title } };
    const newMarkers = [...this.state.mapMarkers];
    newMarkers.push(marker);
    this.setState({ mapMarkers: newMarkers });
    if (this.props.onMapClick) {
      this.props.onMapClick({
        newMarkers
      });
    }
  };

  render() {
    const {
      markerSize,
      markerColor,
      className,
      courtSketch,
      imageHeight,
      imageWidth,
      mapAreas,
      isClickable,
      isOneSide,
      onEventClick,
      hasTooltip
    } = this.props;
    let id = 0;
    const oneSideTransform = isOneSide
      ? "rotateX(55deg) scale(-1.5) rotateZ(90deg)"
      : "";

    const markers = this.state.mapMarkers.map((marker, i) => {
      const playerName =
        marker &&
        marker.taggedUsers &&
        marker.taggedUsers.length > 0 &&
        marker.taggedUsers[0].firstName;
      const uniqueId = generate();
      return (
        <Fragment key={generate()}>
          <span
            key={`${marker.position.x}.${marker.position.y} ${id++}`}
            onClick={() => onEventClick(marker)}
            data-for={`player-${uniqueId}`}
            data-tip
            style={{
              position: "absolute",
              height: `${markerSize}px`,
              width: `${markerSize}px`,
              top: `${this.calcYCoord(marker.position)}px`,
              left: `${this.calcXCoord(marker.position) - markerSize / 2}px`,
              background: marker.markerColor ? marker.markerColor : markerColor,
              borderRadius: "50%"
            }}
          />
          {hasTooltip &&
            playerName && (
              <PlayerTooltip
                playerDetails={marker.taggedUsers[0]}
                uniqueId={uniqueId}
              />
            )}
        </Fragment>
      );
    });

    return (
      <div
        style={{ position: "relative", display: "inline-block" }}
        className={className}
      >
        <img
          ref={this.imgRef}
          src={courtSketch}
          style={{ width: `${imageWidth}px`, height: `${imageHeight}px` }}
          useMap="#image-map"
          alt="map"
        />
        <ImageMapper
          areas={mapAreas}
          onClick={isClickable ? this.handleMapClick : () => {}}
        />
        {markers}
      </div>
    );
  }
}

export default ImageMarker;
